import apiTransactionSetStatus from './functions/apiTransactionSetStatus';

const transaction = {
  transactionSetStatus: apiTransactionSetStatus
};

export default transaction;
